import React from "react";
import { createUseStyles } from "react-jss";
import Checkbox from "../../refresh/inputs/Checkbox";
import TextArea from "../../refresh/inputs/TextArea";
import ReactQuill from "react-quill";

const useStyles = createUseStyles(() => ({
  checkboxRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fontSizeContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
  },
}));

const TextElement = ({ onChange, value }) => {
  const classes = useStyles();
  switch (value.format) {
    case "plaintext":
    case "title":
      return (
        <>
          <TextArea
            label="Content"
            required
            value={value.content}
            onChange={content => onChange({ format: value.format, content })}
          />
          <div className={classes.checkboxRow}>
            <Checkbox
              value={value.format === "title"}
              onChange={format =>
                onChange({
                  format: format ? "title" : "plaintext",
                  content: value.content,
                })
              }
            >
              Display as a title
            </Checkbox>
            {value.format === "title" ? (
              <div className={classes.fontSizeContainer}>
                <span style={{ marginRight: 20 }}>Fontsize</span>
                <select
                  value={value.fontSize || 32}
                  onChange={e => {
                    onChange({
                      ...value,
                      fontSize: Number(e.target.value),
                    });
                  }}
                >
                  <option>Choose size</option>
                  <option value={14}>14</option>
                  <option value={16}>16</option>
                  <option value={20}>20</option>
                  <option value={24}>24</option>
                  <option value={32}>32</option>
                </select>
              </div>
            ) : (
              <div />
            )}
          </div>
        </>
      );
    case "richtext":
      return (
        <ReactQuill
          theme="snow"
          value={value.content}
          onChange={content => {
            onChange({
              ...value,
              content,
            });
          }}
        />
      );
    default:
      return null;
  }
};

export default TextElement;
